import { gql } from "@apollo/client";
import { RegisteredVehicleSummary, registeredVehicleSummaryFragment } from "./registeredVehicleFragment";

export const enforcementActiveScofflawFragment = gql`
  fragment enforcementActiveScofflawFragment on enforcement_active_scofflaw {
    registeredVehicleId: registered_vehicle_id
    registeredVehicle: registered_vehicle {
      ...registeredVehicleSummaryFragment
    }
    numOutstandingIntents: num_outstanding_intents
    scofflawBeginAt: scofflaw_begin_at
  }
  ${registeredVehicleSummaryFragment}
`;

export interface EnforcementActiveScofflaw {
  registeredVehicleId: string;
  registeredVehicle: RegisteredVehicleSummary;
  numOutstandingIntents: number;
  scofflawBeginAt: string;
}
